"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadApp = exports.handleClick = exports.downloadHandle = exports.getDownloadUrl = exports.downloadNow = exports.getQueryFromParams = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var enum_1 = require("../../enum");
var is_server_1 = tslib_1.__importDefault(require("../../_util/is-server"));
var wemeetJumpTimeOut = null;
// 是否是外网域名
var isVooV = !is_server_1.default && window.location.origin.includes('voovmeeting.com');
var IS_I18N = process.env.IS_I18N === 'true';
var downloadUrlWinRooms = 'https://updatecdn.meeting.qq.com/7d6854f2b731cc29782bfdf6214c289e/TMRInstaller_1410000391_2.7.5.518.publish.exe';
var downloadUrlMacRooms = 'https://updatecdn.meeting.qq.com/be87fb1d6e347b8651d1439613c62871/TMRInstaller_1410000391_2.7.5.514.publish.pkg';
/**
 * 获取type对应链接
 * **/
var selectTypeUrl = function (type) {
    switch (type) {
        case 'voov':
            return enum_1.EnumDownload.VOOV_DOWNLOAD_URL;
        case 'win':
            return enum_1.EnumDownload.WIN_DOWNLOAD_URL;
        case 'ios':
            return enum_1.EnumDownload.IOS_DOWNLOAD_URL;
        case 'mac-apple':
            return enum_1.EnumDownload.MAC_DOWNLOAD_URL;
        case 'mac-intel':
            return enum_1.EnumDownload.MAC_DOWNLOAD_URL;
        case 'android':
            return enum_1.EnumDownload.ANDROID_DOWNLOAD_URL;
        case 'linux':
            return enum_1.EnumDownload.LINUX_DOWNLOAD_URL;
        case 'beta':
            return enum_1.EnumDownload.BETA_DOWNLOAD_URL;
        case 'center':
            return enum_1.EnumDownload.DOWNLOAD_URL;
        default:
            return enum_1.EnumDownload.DOWNLOAD_URL;
    }
};
/**
 * 获取下载页当前页面需要的参数 from和fromSource
 * @returns
 */
var getQueryFromParams = function () {
    if (is_server_1.default)
        return {};
    var queryObject = (0, web_base_1.getQueryObject)();
    var fromVal = queryObject.from || '1000';
    var fromSourceVal = queryObject.fromSource || queryObject.from_fromSource || '0';
    var $qrSrc = queryObject.qr_src || '0'; // 1: 从官网的下载中心扫码下载;
    var type = queryObject.type || ''; // type linux携带
    var roomsChannel = queryObject.roomsChannel || ''; // rooms
    return {
        fromVal: fromVal,
        fromSourceVal: fromSourceVal,
        $qrSrc: $qrSrc,
        type: type,
        roomsChannel: roomsChannel,
    };
};
exports.getQueryFromParams = getQueryFromParams;
/**
 * 下载安装包
 */
var downloadNow = function (downloadUrl, defaultUrl) {
    if (downloadUrl === void 0) { downloadUrl = ''; }
    if (defaultUrl === void 0) { defaultUrl = ''; }
    setTimeout(function () {
        if (downloadUrl) {
            window.location.replace(downloadUrl);
        }
        else {
            if (defaultUrl) {
                window.location.replace(defaultUrl);
            }
        }
    }, 600);
};
exports.downloadNow = downloadNow;
// 打开蒙层引导下载
var showShowDownload = function (setShadowShow) {
    var _a = (0, exports.getQueryFromParams)(), fromVal = _a.fromVal, fromSourceVal = _a.fromSourceVal;
    var url = "/download.html?from=".concat(fromVal, "&fromSource=").concat(fromSourceVal);
    if ((0, web_base_1.isAndroid)()) {
        url = "/download-android.html?from=".concat(fromVal, "&fromSource=").concat(fromSourceVal);
    }
    else if ((0, web_base_1.isIOS)()) {
        url = "/download-ios.html?from=".concat(fromVal, "&fromSource=").concat(fromSourceVal);
    }
    setTimeout(function () {
        window.history.pushState({ url: window.location.href }, document.title, url);
        setShadowShow();
    }, 600);
};
/**
 * 查询安装包
 * @param num 轮训次数
 * @param config 查询参数
 * @param downParams 参数
 * @param reload 是否轮训标志
 */
var getDownloadUrl = function (num, config, downParams, reload) {
    if (config === void 0) { config = {}; }
    if (downParams === void 0) { downParams = {}; }
    if (reload === void 0) { reload = true; }
    if ((0, web_base_1.isIOS)())
        return;
    var newData = Object.assign({}, tslib_1.__assign({}, config));
    var defaultUrl = ''; // 默认下载地址，接口没有获取到时
    if (downParams.sys === 'rooms') {
        defaultUrl = (downParams.type === 2) ? downloadUrlMacRooms : downloadUrlWinRooms;
    }
    // 第一次查询失败，则默认使用会议的渠道
    if (reload && num === 2) {
        newData = tslib_1.__assign(tslib_1.__assign({}, config), { channel: '0300000000' });
    }
    var nonce = (0, web_base_1.randomString)(16);
    var fixData = encodeURIComponent(JSON.stringify([newData]));
    (0, web_base_1.get)({
        url: "/query-download-info?q=".concat(fixData),
        prefix: enum_1.HttpPrefix.WEB_SERVICE,
        params: {
            nonce: nonce,
        },
    }).then(function (res) {
        var _a;
        var code = res.code;
        var list = res['info-list'];
        if (code === 0 && list && list.length && ((_a = list[0]) === null || _a === void 0 ? void 0 : _a.url)) {
            // 不支持国际版android扫码跳到google play下载，先临时处理写死国际版android下载链接，后续跟进
            if (IS_I18N && (0, web_base_1.isAndroid)()) {
                var downloadUrl = 'https://play.google.com/store/apps/details?id=com.tencent.voov';
                window.location.replace(downloadUrl);
                return;
            }
            (0, exports.downloadNow)(list[0].url, defaultUrl);
        }
        else {
            if (reload && num === 1) {
                (0, exports.getDownloadUrl)(2, newData);
            }
        }
    });
};
exports.getDownloadUrl = getDownloadUrl;
/**
 * 下载处理
 * @param sys 类型： mac linux windows outlook
 * @param params 参数
 */
var downloadHandle = function (sys, navigationParams) {
    var _a, _b;
    if (sys === void 0) { sys = ''; }
    if (navigationParams === void 0) { navigationParams = {}; }
    var reload = true;
    var fromVals = (0, exports.getQueryFromParams)();
    // 新的参数
    var newParams = Object.assign({}, tslib_1.__assign(tslib_1.__assign({ sys: sys }, fromVals), navigationParams));
    // 埋点参数
    var beaconParams = {
        from: newParams === null || newParams === void 0 ? void 0 : newParams.fromVal,
        qr_src: newParams === null || newParams === void 0 ? void 0 : newParams.$qrSrc,
        from_source: newParams === null || newParams === void 0 ? void 0 : newParams.fromSourceVal,
    };
    // 渠道号
    var channel = '0300000000';
    if ((_a = newParams === null || newParams === void 0 ? void 0 : newParams.fromSourceVal) === null || _a === void 0 ? void 0 : _a.includes('sem')) {
        channel = String((_b = newParams === null || newParams === void 0 ? void 0 : newParams.fromSourceVal) === null || _b === void 0 ? void 0 : _b.split('_')[0]);
    }
    // 下载参数配置项
    var dataConfig = {};
    // 新的参数
    switch (sys) {
        case 'mac': {
            var macType = (newParams === null || newParams === void 0 ? void 0 : newParams.macType) || 'intel'; // mac下载包新增Apple芯片版，新增该字段区分包类型
            beaconParams.mac_type = macType;
            var instance = 'mac';
            if (macType === 'apple') {
                instance = 'mac_arm64';
            }
            dataConfig = {
                'package-type': 'app',
                channel: channel,
                platform: 'mac',
                arch: instance === 'mac_arm64' ? 'arm64' : 'x86_64',
            };
            break;
        }
        case 'windows':
            dataConfig = {
                'package-type': 'app',
                channel: channel,
                platform: 'windows',
            };
            break;
        case 'linux':
            dataConfig = {
                'package-type': 'app',
                channel: channel,
                platform: 'linux',
                arch: newParams.type === 'arm64' ? 'arm64' : 'x86_64',
                decorators: ['deb'],
            };
            break;
        case 'outlook':
            reload = false;
            dataConfig = {
                'package-type': 'outlook',
                channel: '0300000000',
                platform: 'windows',
            };
            break;
        case 'rooms':
            reload = false;
            dataConfig = (newParams.type === 2) ? {
                'package-type': 'rooms',
                channel: newParams.roomsChannel || '1410000391',
                platform: 'mac',
                arch: 'x86_64',
            } : {
                'package-type': 'rooms',
                channel: newParams.roomsChannel || '1410000391',
                platform: 'windows',
            };
            break;
        case 'android':
            dataConfig = {
                'package-type': 'app',
                channel: channel,
                platform: 'android',
            };
            break;
        case 'ios': {
            var url = 'https://itunes.apple.com/cn/app/id1484048379';
            if (IS_I18N) {
                url = 'https://apps.apple.com/app/tencent-meeting/id1497685373';
            }
            (0, exports.downloadNow)(url);
            return;
        }
        default:
            break;
    }
    (0, exports.getDownloadUrl)(1, dataConfig, newParams, reload);
};
exports.downloadHandle = downloadHandle;
var handleClick = function (setShadowShow) {
    var _a;
    var os = (0, web_base_1.getOsName)();
    var _b = (0, exports.getQueryFromParams)(), fromVal = _b.fromVal, fromSourceVal = _b.fromSourceVal;
    var googleEvent = 'Download_Download_Meeting_Android';
    var normalParams = {
        userid: '',
        download_param: 'Android',
        from: fromVal,
        from_source: fromSourceVal,
    };
    if ((0, web_base_1.isIOS)()) {
        normalParams.download_param = 'IOS';
        googleEvent = 'Download_Download_Meeting_iOS';
    }
    (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: googleEvent });
    // 微信浏览器
    if ((0, web_base_1.isWechat)()) {
        // 尝试开始下载
        (0, exports.downloadHandle)(os);
        // 可视层是否变化，即 用户是否去下载
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState !== 'visible') {
                window.clearTimeout(wemeetJumpTimeOut);
            }
        });
        // 3秒内没有下载 显示引导层
        wemeetJumpTimeOut = setTimeout(function () {
            setShadowShow();
        }, 3000);
    }
    else if ((0, web_base_1.isWxWork)() || (0, web_base_1.isQQ)()) {
        // 企微 qq内置浏览器 出蒙层
        showShowDownload(function () {
            setShadowShow();
        });
    }
    else {
        (0, exports.downloadHandle)(os);
    }
};
exports.handleClick = handleClick;
/**
 * 根据不同的系统，跳转下载页面
 *
 * @returns {String} link; 指定跳转地址链接
 * @returns {String} type: 下载类型 'voov' | 'android' | 'ios' | 'win' | 'linux' | 'beta' | 'mac-apple' | 'mac-intel'
 * @returns {String} openType: 'open' or 'replace'; 页面打开方式
 */
var downloadApp = function (link, type, openType) {
    if (link === void 0) { link = ''; }
    if (openType === void 0) { openType = 'open'; }
    var downLoadUrl = enum_1.EnumDownload.DOWNLOAD_URL; // 默认是下载中心
    try {
        var filterXss = function (text) { return text.replace(/[<>"()]/g, ''); };
        if (link) {
            downLoadUrl = link;
        }
        else {
            // 处理链接参数
            var searchParams = location.search || '';
            if (type) {
                // 根据传入的type判断
                downLoadUrl = selectTypeUrl(enum_1.EnumType[type]);
                // 指定mac版本时，默认下载intel。如果是 apple版本 链接加macType参数
                if (type === enum_1.EnumType['mac-apple']) {
                    searchParams = searchParams
                        ? "?macType=apple&".concat(searchParams.substring(1))
                        : '?macType=apple';
                }
            }
            else {
                // 自动根据当前系统判断
                if (isVooV) {
                    downLoadUrl = enum_1.EnumDownload.VOOV_DOWNLOAD_URL;
                }
                else if ((0, web_base_1.getOsName)() === 'windows') {
                    downLoadUrl = enum_1.EnumDownload.WIN_DOWNLOAD_URL;
                }
                else if ((0, web_base_1.isIOS)() || (0, web_base_1.isIpad)()) {
                    downLoadUrl = enum_1.EnumDownload.IOS_DOWNLOAD_URL;
                }
                else if ((0, web_base_1.isMac)()) {
                    // 没有指定mac类型，直接跳转到 下载中心。因为部分 mac 无法准确判断 是什么芯片的
                    downLoadUrl = enum_1.EnumDownload.DOWNLOAD_URL;
                }
                else if ((0, web_base_1.isAndroid)()) {
                    downLoadUrl = enum_1.EnumDownload.ANDROID_DOWNLOAD_URL;
                }
                else if ((0, web_base_1.isLinux)()) {
                    downLoadUrl = enum_1.EnumDownload.LINUX_DOWNLOAD_URL;
                }
            }
            downLoadUrl = filterXss("".concat(downLoadUrl).concat(decodeURIComponent(searchParams)));
        }
        // 打开方式处理
        if (openType === 'open') {
            !is_server_1.default && window.open(downLoadUrl);
        }
        else {
            location.href = downLoadUrl;
        }
    }
    catch (error) {
        !is_server_1.default && window.open(downLoadUrl);
    }
};
exports.downloadApp = downloadApp;
//# sourceMappingURL=index.js.map